import http from "@/http"
import { OrderAttachmentType } from "@/interfaces/global"

const MULTI_PART_HEADERS = {
  "Content-Type": "multipart/form-data"
}

export const getOrderAttachments = async function(orderId: number): Promise<OrderAttachmentType[]> {
  const { data } = await http.get(`orders/${orderId}/attachments`)
  return data
}

export const saveOrderAttachment = async function(
  orderId: number, 
  file: File, 
  displayOrder: number,
) {
  const formData = new FormData()
  formData.append("files", file, file.name)
  formData.append("fileName", file.name)
  formData.append("displayOrder", String(displayOrder))
  return await http.post(
    `orders/${orderId}/attachments`, 
    formData, 
    { headers: MULTI_PART_HEADERS }
  )
}

export const getOrderHistoryIdList = async function(orderId: number): Promise<number[]> {
  const { data } = await http.get(`orders/${orderId}/history-id-list`)
  return data
}

export const updateOrderAttachmentsStatus = async function(orderId: number, statusId: number) {
  await http.post(`orders/${orderId}/attachments/status/${statusId}`)
}

export const deleteOrderAttachment = async function(
  orderId: number, 
  attachmentId: number
) {
  return await http.delete(`orders/${orderId}/attachments/${attachmentId}`)
}